import "./App.css";
import { Report,ReportNew } from "./components";
import ReportPriority from "./ReportPriority/ReportPriority";


function App() {
  return (
    <div> 
      <Report />
      {/* <ReportNew/> */}
    </div>
  );
}

export default App;
